import AnalysesPage from '../dashboard/analyses/AnalysesPage'
import AnalysisChainPage from '../dashboard/analysis-chains/AnalysisChainPage'
import AnalysisChainsPage from '../dashboard/analysis-chains/AnalysisChainsPage'
import AnalysisPage from '../dashboard/analyses/AnalysisPage'
import CreateAnalysisChainPage from '../dashboard/analysis-chains/CreateAnalysisChainPage'
import CreateAnalysisPage from '../dashboard/analyses/CreateAnalysisPage'
import CreateDataTypePage from '../dashboard/data-types/createDataTypePage'
import CreateDevicePage from '../dashboard/devices/CreateDevicePage'
import CreateOrganizationPage from '../dashboard/organizations/CreateOrganizationPage'
import CreateRolePage from '../dashboard/roles/CreateRolePage'
import EditRolePage from '../dashboard/roles/EditRolePage'
import CreateUserPage from '../dashboard/users/CreateUserPage'
import DataTypePage from '../dashboard/data-types/dataTypePage'
import DataTypesPage from '../dashboard/data-types/dataTypesPage'
import DevicePage from '../dashboard/devices/DevicePage'
import DevicesPage from '../dashboard/devices/DevicesPage'
import EditAnalysisChainPage from '../dashboard/analysis-chains/EditAnalysisChainPage'
import EditAnalysisPage from '../dashboard/analyses/EditAnalysisPage'
import EditDataTypePage from '../dashboard/data-types/editDataTypePage'
import EditDevicePage from '../dashboard/devices/EditDevicePage'
import EditOrganizationPage from '../dashboard/organizations/EditOrganizationPage'
import EditPlotPage from '../dashboard/plots/EditPlotPage'
import EditUserPage from '../dashboard/users/EditUserPage'
import EntityDetailTemplate from '../templates/EntityDetailTemplate'
import ExperimentsPage from '../dashboard/experiments/ExperimentsPage'
import HardwareListPage from '../dashboard/hardware/HardwareListPage'
import HollometersListPage from '../dashboard/hollometers/HollometersListPage'
import Loadable from '../components/common/Loadable'
import ManualTriggerPage from '../dashboard/manualTrigger/ManualTriggerPage'
import { Navigate } from 'react-router-dom'
import OrganizationPage from '../dashboard/organizations/OrganizationPage'
import OrganizationsPage from '../dashboard/organizations/OrganizationsPage'
import PlotConfigurationPage from '../pages/PlotConfigurationPage'
import PlotPage from '../dashboard/plots/PlotPage'
import ProtectedRoute from '../components/ProtectedRoute'
import ResetPassword from '../pages/auth/ResetPassword'
import RolePage from '../dashboard/roles/RolePage'
import RolesPage from '../dashboard/roles/RolesPage'
import TwoFactorAuth from '../pages/auth/TwoFactorAuth'
import TwoFactorAuthSetup from '../pages/auth/TwoFactorAuthSetup'
import UserPage from '../dashboard/users/UserPage'
import UserProfilePage from '../dashboard/users/UserProfilePage'
import UsersPage from '../dashboard/users/UsersPage'
import { lazy } from 'react'
import { resolveNavPath } from '../utilities/pathMapping'

const OverviewPage = Loadable(lazy(() => import('../pages/DataViewerPage')))

const MainRoutes = {
  path: '/',
  children: [
    { path: '/', element: <Navigate to="/data-viewer" replace /> },
    {
      path: '/data-viewer',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<OverviewPage />}
          allowedRoles={['admin', 'organization_admin']}
        />
      ),
    },
    {
      path: '/2fa',
      children: [
        {
          path: '/2fa/setup',
          layoutType: 'particleBackground',
          element: <ProtectedRoute element={<TwoFactorAuthSetup />} />,
        },
        {
          path: '/2fa/verify',
          layoutType: 'particleBackground',
          element: <TwoFactorAuth />,
        },
      ],
    },
    {
      path: '/password/reset',
      layoutType: 'particleBackground',
      element: <ResetPassword />,
    },
    {
      path: '/roles',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<RolesPage />}
          allowedRoles={['admin', 'organization_admin']}
        />
      ),
    },
    {
      path: '/roles/:uuid',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<RolePage />}
          allowedRoles={['admin', 'organization_admin']}
        />
      ),
    },
    {
      path: '/roles/:uuid/edit',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<EditRolePage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: '/roles/create',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<CreateRolePage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: '/plot-config',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<PlotConfigurationPage />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/plot-config/create',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<EditPlotPage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: '/plot-config/:uuid',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<PlotPage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: '/plot-config/:uuid/edit',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<EditPlotPage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: '/devices',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<DevicesPage />}
          allowedRoles={['admin', 'organization_admin']}
        />
      ),
    },
    {
      path: '/devices/:uuid',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<DevicePage />}
          allowedRoles={['admin', 'organization_admin']}
        />
      ),
    },
    {
      path: '/devices/create',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<CreateDevicePage />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/devices/:uuid/edit',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<EditDevicePage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: `/${resolveNavPath('stations')}`,
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<HollometersListPage />}
          allowedRoles={['admin', 'supervisor', 'technician']}
        />
      ),
    },
    {
      path: `/${resolveNavPath('stations')}/:uuid`,
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={
            <EntityDetailTemplate
              endpoint="stations"
              responsibleRoles={['admin', 'supervisor']}
            />
          }
          allowedRoles={['admin', 'supervisor', 'technician']}
        />
      ),
    },
    {
      path: `/${resolveNavPath('stations')}/create`,
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={
            <EntityDetailTemplate
              endpoint="stations"
              responsibleRoles={['admin', 'supervisor']}
            />
          }
          allowedRoles={['admin', 'supervisor', 'technician']}
        />
      ),
    },
    {
      path: '/hardware',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<HardwareListPage />}
          allowedRoles={['admin', 'supervisor', 'technician']}
        />
      ),
    },
    {
      path: '/hardware/:uuid',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={
            <EntityDetailTemplate
              endpoint="hardware"
              responsibleRoles={['admin', 'supervisor']}
            />
          }
          allowedRoles={['admin', 'supervisor', 'technician']}
        />
      ),
    },
    {
      path: '/hardware/create',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={
            <EntityDetailTemplate
              endpoint="hardware"
              responsibleRoles={['admin', 'supervisor']}
            />
          }
          allowedRoles={['admin', 'supervisor', 'technician']}
        />
      ),
    },
    {
      path: '/experiments',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<ExperimentsPage />}
          allowedRoles={['admin', 'organization_admin', 'user']}
        />
      ),
    },
    {
      path: '/organizations',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<OrganizationsPage />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/organizations/:uuid',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<OrganizationPage />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/organizations/:uuid/edit',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<EditOrganizationPage />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/organizations/create',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<CreateOrganizationPage />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/users',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<UsersPage />} allowedRoles={['admin']} />
      ),
    },

    {
      path: '/users/:uuid',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<UserPage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: '/users/:uuid/edit',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<EditUserPage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: '/users/create',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<CreateUserPage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: '/users/me',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<UserProfilePage />}
          allowedRoles={['admin', 'organization_admin', 'user']}
        />
      ),
    },
    {
      path: '/analysis-chains',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<AnalysisChainsPage selectMode={false} />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/analysis-chains/:uuid',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<AnalysisChainPage />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/analysis-chains/create',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<CreateAnalysisChainPage />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/analysis-chains/:uuid/edit',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<EditAnalysisChainPage />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/manual-trigger',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<ManualTriggerPage />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/analyses',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<AnalysesPage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: '/analyses/:uuid',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<AnalysisPage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: '/analyses/create',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<CreateAnalysisPage />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/analyses/:uuid/edit',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<EditAnalysisPage />}
          allowedRoles={['admin']}
        />
      ),
    },

    {
      path: '/data-types',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<DataTypesPage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: '/data-types/:uuid',
      layoutType: 'default',
      element: (
        <ProtectedRoute element={<DataTypePage />} allowedRoles={['admin']} />
      ),
    },
    {
      path: '/data-types/:uuid/edit',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<EditDataTypePage />}
          allowedRoles={['admin']}
        />
      ),
    },
    {
      path: '/data-types/create',
      layoutType: 'default',
      element: (
        <ProtectedRoute
          element={<CreateDataTypePage />}
          allowedRoles={['admin']}
        />
      ),
    },
  ],
}

export default MainRoutes
